import React from "react";
import { Button } from "antd";
import * as Style from "./UserDefinedRowStyle";

function UserDefinedRow({ allItems, getSelectedRow, deleteRow }) {
  console.log("items to display", allItems);

  return (
    <React.Fragment>
      {allItems &&
        allItems.map((item, itemIndex) => (
          <Style.MainContainer key={itemIndex}>
            <Style.IndexConatiner>{itemIndex + 1}</Style.IndexConatiner>
            <Style.ContentConatiner>
              {Object.keys(item)
                .filter(
                  (key) =>
                    ![
                      "clientId",
                      "createdAt",
                      "deleted",
                      "enable",
                      "updatedAt",
                      "id",
                    ].includes(key)
                )
                .map((key, index1) => (
                  <Style.Item key={index1}>
                    <span style={{ fontWeight: "bolder",textTransform:"capitalize" }}>{key} : </span>{" "}
                    {item[key]}
                  </Style.Item>
                ))}
            </Style.ContentConatiner>
            <Style.ButtonsContainer>
              <Button
                type="link"
                style={{ fontSize: "21px" }}
                icon="edit"
                onClick={() => getSelectedRow(item.id)}
              ></Button>
              <Button
                type="link"
                style={{ fontSize: "21px" }}
                icon="delete"
                onClick={() => deleteRow(item.id)}
              ></Button>
            </Style.ButtonsContainer>
          </Style.MainContainer>
        ))}
    </React.Fragment>
  );
}

export default UserDefinedRow;
